import { render, staticRenderFns } from "./SMSTemplateManagement.vue?vue&type=template&id=6805f284&scoped=true"
import script from "./SMSTemplateManagement.vue?vue&type=script&lang=js"
export * from "./SMSTemplateManagement.vue?vue&type=script&lang=js"
import style0 from "./SMSTemplateManagement.vue?vue&type=style&index=0&id=6805f284&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6805f284",
  null
  
)

export default component.exports